import Switch from '@shared/components/Switch/Switch';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import { useWebPushContext } from 'contexts/WebPushContext/WebPushContext';

const PushNotificationsRow = () => {
  const { isPushSupported, isPushEnabled, pushPermission, enablePush, disablePush } = useWebPushContext();
  const { matrixClient } = useMatrixContext();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  if (!isPushSupported) return null;

  const isPushDenied = pushPermission === 'denied';

  const handleToggle = async () => {
    if (isPushDenied || isLoading) return;
    setIsLoading(true);
    try {
      if (isPushEnabled) {
        await disablePush(matrixClient.getAccessToken() ?? '');
      } else {
        await enablePush(matrixClient.getAccessToken() ?? '');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex gap-4 items-start w-full py-1">
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <p className="text-sm font-medium text-grayscale-black">{t('notifications.push_notifications')}</p>
        <p className="text-sm font-light text-gray-80">
          {isPushDenied ? t('notifications.push_blocked_description') : t('notifications.push_description')}
        </p>
      </div>
      <Switch checked={isPushEnabled} onChange={handleToggle} disabled={isPushDenied || isLoading} />
    </div>
  );
};

export default PushNotificationsRow;
